import styled from "styled-components";

export const InquiryIncidentModalStyle = styled.div`
	.ant-radio-wrapper {
		display: block;
		margin-bottom: 4px;
	}
`;
